import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useNotifications } from '../contexts/NotificationContext';
import useIsMobile from '../hooks/useIsMobile';

const Navigation = () => {
  const { user } = useAuth();
  const { unreadCount, openPanel } = useNotifications();
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const isMobile = useIsMobile();
  
  // Dashboard: JEFE (ejecutivo) y PERSONAL (mi trabajo)
  const tieneDashboard = user && (user.rol === 'JEFE' || user.rol === 'PERSONAL');

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light" style={{ 
        background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
        position: 'relative',
        borderBottom: '2px solid #e9ecef',
        minHeight: isMobile ? '50px' : 'auto',
        height: isMobile ? '50px' : 'auto',
        padding: 0
      }}>
        {/* Sidebar mobile con links - Solo en MOBILE */}
        {isMobile && (
          <div 
            className="mobile-nav"
            style={{
              display: menuOpen ? 'flex' : 'none',
              position: 'fixed',
              top: '0',
              left: '0',
              width: '250px',
              height: '100vh',
              background: '#ffffff',
              flexDirection: 'column',
              padding: '60px 0 20px 0',
              zIndex: 1000,
              boxShadow: '4px 0 20px rgba(0,0,0,0.15)',
              transition: 'transform 0.3s ease',
              overflowY: 'auto',
              borderRight: '1px solid #e9ecef'
            }}
          >
            <NavLink 
              to="/expedientes" 
              className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
              onClick={() => setMenuOpen(false)}
              style={({ isActive }) => ({
                color: isActive ? 'white' : '#2c3e50',
                textDecoration: 'none',
                padding: '14px 20px',
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                borderRadius: '8px',
                margin: '4px 12px',
                background: isActive ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : 'transparent',
                transition: 'all 0.3s ease',
                fontWeight: isActive ? '600' : '500',
                fontSize: '0.95rem'
              })}
            >
              <i className="fas fa-folder-open" style={{ fontSize: '1.1rem' }}></i>
              Expedientes
            </NavLink>

            {tieneDashboard && (
              <NavLink 
                to="/dashboard" 
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                onClick={() => setMenuOpen(false)}
                style={({ isActive }) => ({
                  color: isActive ? 'white' : '#2c3e50',
                  textDecoration: 'none',
                  padding: '14px 20px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  borderRadius: '8px',
                  margin: '4px 12px',
                  background: isActive ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : 'transparent',
                  transition: 'all 0.3s ease',
                  fontWeight: isActive ? '600' : '500',
                  fontSize: '0.95rem'
                })}
              >
                <i className="fas fa-chart-line" style={{ fontSize: '1.1rem' }}></i>
                Dashboard
              </NavLink>
            )}

            <NavLink 
              to="/calendario" 
              className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
              onClick={() => setMenuOpen(false)}
              style={({ isActive }) => ({
                color: isActive ? 'white' : '#2c3e50',
                textDecoration: 'none',
                padding: '14px 20px',
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                borderRadius: '8px',
                margin: '4px 12px',
                background: isActive ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : 'transparent',
                transition: 'all 0.3s ease',
                fontWeight: isActive ? '600' : '500',
                fontSize: '0.95rem'
              })}
            >
              <i className="fas fa-calendar-alt" style={{ fontSize: '1.1rem' }}></i>
              Calendario
            </NavLink>
            
            <NavLink 
              to="/herramientas" 
              className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
              onClick={() => setMenuOpen(false)}
              style={({ isActive }) => ({
                color: isActive ? 'white' : '#2c3e50',
                textDecoration: 'none',
                padding: '14px 20px',
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                borderRadius: '8px',
                margin: '4px 12px',
                background: isActive ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : 'transparent',
                transition: 'all 0.3s ease',
                fontWeight: isActive ? '600' : '500',
                fontSize: '0.95rem'
              })}
            >
              <i className="fas fa-tools" style={{ fontSize: '1.1rem' }}></i>
              Herramientas
            </NavLink>
            
            <NavLink 
              to="/configuracion" 
              className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
              onClick={() => setMenuOpen(false)}
              style={({ isActive }) => ({
                color: isActive ? 'white' : '#2c3e50',
                textDecoration: 'none',
                padding: '14px 20px',
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                borderRadius: '8px',
                margin: '4px 12px',
                background: isActive ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : 'transparent',
                transition: 'all 0.3s ease',
                fontWeight: isActive ? '600' : '500',
                fontSize: '0.95rem'
              })}
            >
              <i className="fas fa-cog" style={{ fontSize: '1.1rem' }}></i>
              Configuración
            </NavLink>
          </div>
        )}

        {/* Container para DESKTOP solamente */}
        {!isMobile && (
          <div className="container" style={{ position: 'relative' }}>
            <div 
              className="navbar-nav me-auto"
              style={{ display: 'flex', flexDirection: 'row' }}
            >
              <NavLink 
                to="/expedientes" 
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
              >
                <i className="fas fa-folder-open" style={{ marginRight: '8px' }}></i>
                Expedientes
              </NavLink>

              {tieneDashboard && (
                <NavLink 
                  to="/dashboard" 
                  className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                >
                  <i className="fas fa-chart-line" style={{ marginRight: '8px' }}></i>
                  Dashboard
                </NavLink>
              )}

              <NavLink 
                to="/calendario" 
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
              >
                <i className="fas fa-calendar-alt" style={{ marginRight: '8px' }}></i>
                Calendario
              </NavLink>
              
              <NavLink 
                to="/herramientas" 
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
              >
                <i className="fas fa-tools" style={{ marginRight: '8px' }}></i>
                Herramientas
              </NavLink>
              
              <NavLink 
                to="/configuracion" 
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
              >
                <i className="fas fa-cog" style={{ marginRight: '8px' }}></i>
                Configuración
              </NavLink>
            </div>
            
            {user && (
              <div 
                className="navbar-nav ms-auto" 
                style={{ 
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px'
                }}
              >
                {/* Botón de notificaciones */}
                <button
                  className="notification-btn"
                  onClick={openPanel}
                  title="Notificaciones"
                >
                  {unreadCount > 0 && (
                    <span className="notification-badge">
                      {unreadCount}
                    </span>
                  )}
                </button>
              
                <div className="nav-item dropdown" style={{ position: 'relative' }}>
                  <button 
                    className="user-menu-trigger"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setShowUserMenu(!showUserMenu);
                    }}
                    style={{ 
                      cursor: 'pointer',
                      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                      border: 'none',
                      color: 'white',
                      padding: '8px 16px',
                      borderRadius: '20px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      transition: 'all 0.3s ease',
                      boxShadow: '0 2px 8px rgba(102, 126, 234, 0.3)',
                      fontSize: '0.9rem',
                      fontWeight: '500',
                      position: 'relative',
                      zIndex: 1
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-2px)';
                      e.currentTarget.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.4)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 2px 8px rgba(102, 126, 234, 0.3)';
                    }}
                  >
                    <div 
                      style={{
                        width: '32px',
                        height: '32px',
                        borderRadius: '50%',
                        background: 'rgba(255,255,255,0.2)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '1rem'
                      }}
                    >
                      <i className="fas fa-user"></i>
                    </div>
                    <span style={{ fontWeight: '600' }}>{user.nombre.split(' ')[0]}</span>
                    <i 
                      className={`fas fa-chevron-${showUserMenu ? 'up' : 'down'}`} 
                      style={{ 
                        fontSize: '0.7rem',
                        transition: 'transform 0.3s ease',
                        transform: showUserMenu ? 'rotate(180deg)' : 'rotate(0deg)'
                      }}
                    ></i>
                  </button>
                  
                  {showUserMenu && (
                    <>
                      {/* Overlay para cerrar al hacer clic afuera */}
                      <div
                        onClick={() => setShowUserMenu(false)}
                        style={{
                          position: 'fixed',
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          zIndex: 1049,
                          background: 'rgba(0,0,0,0.3)',
                          backdropFilter: 'blur(2px)',
                          animation: 'fadeIn 0.2s ease'
                        }}
                      />
                      
                      <div 
                        className="user-menu"
                        style={{
                          position: 'absolute',
                          top: '100%',
                          right: 0,
                          marginTop: '12px',
                          minWidth: '280px',
                          background: '#ffffff',
                          borderRadius: '16px',
                          boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
                          zIndex: 1050,
                          overflow: 'hidden',
                          border: 'none',
                          animation: 'slideDown 0.3s ease'
                        }}
                      >
                        {/* Header con gradiente */}
                        <div 
                          style={{
                            padding: '24px 20px',
                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            position: 'relative',
                            overflow: 'hidden'
                          }}
                        >
                          {/* Efecto de círculos decorativos */}
                          <div style={{
                            position: 'absolute',
                            top: '-20px',
                            right: '-20px',
                            width: '100px',
                            height: '100px',
                            borderRadius: '50%',
                            background: 'rgba(255,255,255,0.1)',
                          }}></div>
                          <div style={{
                            position: 'absolute',
                            bottom: '-30px',
                            left: '-30px',
                            width: '120px',
                            height: '120px',
                            borderRadius: '50%',
                            background: 'rgba(255,255,255,0.05)',
                          }}></div>
                          
                          <div style={{ position: 'relative', zIndex: 1 }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '14px', marginBottom: '12px' }}>
                              <div 
                                style={{
                                  width: '56px',
                                  height: '56px',
                                  borderRadius: '50%',
                                  background: 'rgba(255,255,255,0.25)',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  fontSize: '1.8rem',
                                  color: 'white',
                                  boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                                }}
                              >
                                <i className="fas fa-user"></i>
                              </div>
                              <div style={{ flex: 1, color: 'white' }}>
                                <p style={{ 
                                  margin: 0, 
                                  fontWeight: '700', 
                                  fontSize: '1.1rem',
                                  marginBottom: '2px',
                                  textShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                }}>
                                  {user.nombre}
                                </p>
                                <p style={{ 
                                  margin: 0, 
                                  fontSize: '0.8rem', 
                                  opacity: 0.95,
                                  fontWeight: '400'
                                }}>
                                  {user.email}
                                </p>
                              </div>
                            </div>
                            <span 
                              style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '6px',
                                padding: '6px 14px',
                                background: 'rgba(255,255,255,0.25)',
                                backdropFilter: 'blur(10px)',
                                borderRadius: '20px',
                                fontSize: '0.75rem',
                                fontWeight: '700',
                                textTransform: 'uppercase',
                                letterSpacing: '0.8px',
                                color: 'white',
                                border: '1px solid rgba(255,255,255,0.3)'
                              }}
                            >
                              <i className="fas fa-shield-alt" style={{ fontSize: '0.9rem' }}></i>
                              {user.rol}
                            </span>
                          </div>
                        </div>
                        
                        {/* Footer con info adicional */}
                        <div style={{
                          padding: '16px 20px',
                          background: '#f8f9fa',
                          borderTop: '1px solid #e9ecef'
                        }}>
                          <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            color: '#6c757d',
                            fontSize: '0.75rem'
                          }}>
                            <i className="fas fa-clock"></i>
                            <span>Última sesión activa</span>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            )}
          </div>
        )}
      </nav>

      {/* Botones de usuario y notificaciones en MOBILE - Siempre visibles */}
      {isMobile && user && (
        <div
          className="mobile-nav-actions"
          style={{
            position: 'fixed',
            top: '10px',
            right: '10px',
            display: 'flex',
            gap: '8px',
            zIndex: 1001
          }}
        >
          <button
            className="navbar-toggler"
            type="button"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setMenuOpen(!menuOpen);
            }}
            style={{
              position: 'relative',
              background: '#ff8c42',
              border: '2px solid #ff7920',
              fontSize: '1.3rem',
              color: 'white',
              cursor: 'pointer',
              zIndex: 11001,
              width: '44px',
              height: '44px',
              borderRadius: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 0.3s ease',
              boxShadow: '0 3px 10px rgba(255, 140, 66, 0.4)',
              pointerEvents: 'auto'
            }}
          >
            <i className={menuOpen ? 'fas fa-times' : 'fas fa-bars'}></i>
          </button>

          {/* Notificaciones en mobile - DORADO */}
          <button
            className="notification-btn-mobile"
            onClick={openPanel}
            title="Notificaciones"
            style={{
              width: '44px',
              height: '44px',
              borderRadius: '10px',
              background: 'linear-gradient(135deg, #ffd700 0%, #ffb700 100%)',
              border: '2px solid #ffa500',
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              boxShadow: '0 3px 10px rgba(255, 215, 0, 0.4)',
              position: 'relative',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = '0 5px 15px rgba(255, 215, 0, 0.5)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = '0 3px 10px rgba(255, 215, 0, 0.4)';
            }}
          >
            <i className="fas fa-bell" style={{ fontSize: '1.2rem' }}></i>
            {unreadCount > 0 && (
              <span 
                style={{
                  position: 'absolute',
                  top: '-5px',
                  right: '-5px',
                  background: '#ef4444',
                  color: 'white',
                  borderRadius: '50%',
                  width: '22px',
                  height: '22px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '0.7rem',
                  fontWeight: 'bold',
                  border: '2px solid white'
                }}
              >
                {unreadCount}
              </span>
            )}
          </button>
        </div>
      )}

      {/* Overlay oscuro cuando el menú está abierto en móvil */}
      {isMobile && menuOpen && (
        <div
          onClick={() => setMenuOpen(false)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 999
          }}
        />
      )}
    </>
  );
};

export default Navigation;
